// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"c79c5586","502":"dec4c112","527":"7d0f862b","821":"c79c5586","919":"c79c5586","956":"c79c5586"}[chunkId] + ".chunk.css";
};